import React, { ComponentType } from 'react';
import { useBrand } from '../OrganizationContext';
import { ILogoColorSchemeProps } from './logos/constants';

export type LogoComponentType = ComponentType<
  { className?: string; width?: number | string; height?: number | string; }
  & ILogoColorSchemeProps
>;

const Logo: LogoComponentType = props => {
  const { LogoComponent } = useBrand();
  return <LogoComponent {...props} />;
};

export default Logo;
